export enum FieldDataType {
  Int = 1,
  Double = 2,
  String = 3,
  DateTime = 4,
  Guid = 5,
  Bool = 6,
}
